import { getABNVariant } from '~/src/helpers/abn-tests';

export const NOT_AUTH_SHOWCASE = {
    testName: 'vas_page_unauthorized',

    variants: {
        on: 'vas_page_unauthorized_on',
        off: 'vas_page_unauthorized_off',
    },
};

export const unauthorizedShowcaseEnabled = () => getABNVariant(NOT_AUTH_SHOWCASE.testName) === NOT_AUTH_SHOWCASE.variants.on;
